module.exports = __webpack_public_path__ + "static/media/Report.0951d753.pdf";